import { Icon, IconButton, Menu } from '@zillow/constellation-10';
import { IconMoreVerticalFilled } from '@zillow/constellation-icons';

export type OverflowMenuItem = {
  label: string;
  onSelect?: () => void;
};

type Props = {
  items: Array<OverflowMenuItem>;
  triggerLabel: string;
  disabled?: boolean;
};

const FlexiblePropertyCardOverflowMenu = ({ items, triggerLabel, disabled = false }: Props) => {
  const stopPropagation = (event: React.SyntheticEvent) => {
    event.stopPropagation();
  };

  return (
    <Menu.Root>
      <Menu.Trigger>
        <IconButton
          aria-label={triggerLabel}
          tone="brand"
          emphasis="bare"
          title={triggerLabel}
          size="md"
          disabled={disabled}
          onClick={stopPropagation}
          data-testid="FlexiblePropertyCard-OverflowMenuTrigger"
        >
          <Icon render={<IconMoreVerticalFilled />} />
        </IconButton>
      </Menu.Trigger>
      <Menu.Portal>
        <Menu.Content>
          {items.map((item) => (
            <Menu.Item
              key={item.label}
              onClick={(event) => {
                stopPropagation(event);
                item.onSelect?.();
              }}
            >
              <Menu.ItemLabel>{item.label}</Menu.ItemLabel>
            </Menu.Item>
          ))}
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  );
};

export { FlexiblePropertyCardOverflowMenu };
